import React, { BaseSyntheticEvent, FC } from "react";
import { AddCircleOutline } from "@mui/icons-material";
import { ErrorMessage, FormikValues, useFormikContext } from "formik";
import { Box, Button, Divider, Input } from "@mui/material";

import FileUploadButton from "../../../../common/Form/FileUpload/FileUploadButton";

import IMAGES from "../../../../../constants/images";
import ErrorValidationOnGrid from "../../../../common/Form/Error/ErrorValidationOnGrid";
import { TRAININGS } from "../../../../../constants/forms";

const OtherTrainings: FC = (): JSX.Element => {
  const fieldName = TRAININGS;
  const { values, setFieldValue } = useFormikContext<FormikValues>();

  const inputHandler = (i: number, e: BaseSyntheticEvent, name: string) => {
    const prev = [...values[fieldName]];
    prev[i][name] = e.target.value;
    setFieldValue(fieldName, prev);
  };

  const addMoreHandler = () => {
    setFieldValue(fieldName, [
      ...values[fieldName],
      {
        date: "",
        url: "",
        name: "",
      },
    ]);
  };

  const deleteInputGrid = (i: number) => {
    const prev = [...values[fieldName]];
    if (prev.length > 0) {
      const filteredData = prev.filter((field, index) => i !== index);
      setFieldValue(fieldName, filteredData);
    }
  };

  return (
    <>
      <Box sx={{ mt: 2 }}>
        <label className="form-label mg-b-20">5.1 Trainings</label>
        {values[fieldName].length > 0 &&
          values[fieldName]?.map((item: any, i: number) => (
            <Box key={i} sx={{ mb: 2 }}>
              <Input
                type="text"
                value={item.name}
                onChange={(e: BaseSyntheticEvent) => inputHandler(i, e, "name")}
                className="form-control mg-b-10"
                name="name"
                placeholder="Name of training"
                disableUnderline={true}
              />
              <ErrorValidationOnGrid
                name={fieldName}
                gridName={"name"}
                index={i}
              />

              <Input
                type="date"
                value={item.date}
                onChange={(e: BaseSyntheticEvent) => inputHandler(i, e, "date")}
                className="form-control mg-b-10"
                name="date"
                disableUnderline={true}
              />
              <ErrorValidationOnGrid
                name={fieldName}
                gridName={"date"}
                index={i}
              />

              <Box
                className={`d-flex justify-content-between align-items-center`}
              >
                <FileUploadButton
                  showError={false}
                  name={fieldName}
                  gridName="url"
                  index={i}
                  label="Upload here"
                  className="mg-t-0"
                />
                <Button
                  variant="text"
                  onClick={() => deleteInputGrid(i)}
                  type="button"
                  sx={{
                    minWidth: 0,
                    p: 0,
                  }}
                >
                  <img src={IMAGES.Delete} alt="" />
                </Button>
              </Box>
              <ErrorValidationOnGrid
                name={fieldName}
                gridName={"url"}
                index={i}
              />
            </Box>
          ))}
      </Box>
      <Divider className="mg-y-20" />
      <Button
        variant={"text"}
        color={"error"}
        onClick={addMoreHandler}
        type="button"
      >
        <AddCircleOutline className="mg-r-10" />
        Add Other if any
      </Button>
    </>
  );
};

export default OtherTrainings;
